import { useEffect, useState } from 'react';
import useModal from '@keyslabor/shared/hooks/useModal';
import { Button, Form, Row } from '@keyslabor/shared/ui';
import ModalConfirm from '@/components/ModalConfirm';
import {
  FooterProps,
  ModalConfirmProps,
} from '@/components/ModalConfirm/types';
import Calendar from '@/components/Calendar/Calendar';

interface ComponentProps {
  setValue: (name: 'date', value: Date | undefined) => void;
}

export default function useChooseDate(props: ComponentProps) {
  const [form] = Form.useForm();
  const [date, setDate] = useState<Date>();

  const { onToggle, modalProps, show } = useModal();

  useEffect(() => {
    if (!show) form.resetFields();
  }, [show]);

  const content = (
    <Row width={'100%'} height="100%" justifyContent="center">
      <Calendar
        width="100%"
        value={date}
        padding="0px"
        onDateSelect={(val) => {
          setDate(val);
        }}
        navigationPosition="top"
        maxDate={new Date()}
        margin="auto"
      />
    </Row>
  );

  const Footer = ({ okProps }: FooterProps) => {
    return (
      <Row width="100%" mt="10px">
        <Button
          width="100%"
          height="40px"
          fontSize="14px"
          fontWeight="400"
          onClick={() => {
            props?.setValue('date', date);
            onToggle();
          }}
          {...okProps}
        >
          OK
        </Button>
      </Row>
    );
  };

  const customModalProps: Partial<ModalConfirmProps> = {
    textClose: null,
    children: content,
    full: true,
    drawer: true,
    success: false,
    FooterElement: Footer,
  };

  return [
    <ModalConfirm
      key="create-lost-hour-choose-date"
      drawerHeight={'auto'}
      noBodyPadding
      padding="30px 20px"
      {...customModalProps}
      {...modalProps}
    />,
    (value: Date | undefined) => {
      onToggle();
      setDate(value);
    },
  ] as const;
}
